import { render, staticRenderFns } from "./Publishing.vue?vue&type=template&id=62356ba8&scoped=true&"
import script from "./Publishing.vue?vue&type=script&lang=js&"
export * from "./Publishing.vue?vue&type=script&lang=js&"
import style0 from "./Publishing.vue?vue&type=style&index=0&id=62356ba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62356ba8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/acarmichael/Desktop/DEV/BOSS40-FrontEnd/boss-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout})
